import { useState } from 'react'
import {
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  AuthErrorCodes,
} from 'firebase/auth'
import { useNavigate } from 'react-router-dom'

import { auth, Providers } from '../../config/firebase'
import { LoginForm } from './LoginForm'

interface Props {
  mode: 'login' | 'signup'
  from?: string | null
}

function getErrorMessage(code: string) {
  switch (code) {
    case 'auth/invalid-login-credentials':
    case AuthErrorCodes.INVALID_APP_CREDENTIAL:
    case AuthErrorCodes.INVALID_EMAIL:
    case AuthErrorCodes.INVALID_PASSWORD:
      return 'Invalid email or password'
    case AuthErrorCodes.EMAIL_EXISTS:
      return 'Email already registered'
    default:
      return `An error occurred ${code}`
  }
}

const AuthContainer = ({ mode, from }: Props) => {
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState('')
  const [disabled, setDisabled] = useState(false)

  const onComplete = () => {
    navigate(from || '/')
  }

  const signInWithGoogle = () => {
    setDisabled(true)
    signInWithPopup(auth, Providers.google)
      .then(() => {
        setDisabled(false)
        onComplete()
      })
      .catch((error) => {
        setErrorMessage(getErrorMessage(error.code))
        setDisabled(false)
      })
  }

  const signInWithEmail = (email: string, password: string) => {
    setDisabled(true)
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        setDisabled(false)
        onComplete()
      })
      .catch((error) => {
        setErrorMessage(getErrorMessage(error.code))
        setDisabled(false)
      })
  }

  const createAccount = (email: string, password: string) => {
    setDisabled(true)
    createUserWithEmailAndPassword(auth, email, password)
      .then(() => {
        setDisabled(false)
        onComplete()
      })
      .catch((error) => {
        setErrorMessage(getErrorMessage(error.code))
        setDisabled(false)
      })
  }

  return (
    <LoginForm
      errorMessage={errorMessage}
      disabled={disabled}
      signInWithGoogle={signInWithGoogle}
      signInWithEmail={signInWithEmail}
      createAccount={createAccount}
      mode={mode}
    />
  )
}

export default AuthContainer
